import API from "../../api/apiAdmin";

export const AdminEPKServices = {
    getEPK: async () => {
        const response = await API.get("/admin/epk/");
        return response.data;
    },

    uploadEPK: async (formData) => {
        const response = await API.post("/admin/epk/upload", formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
        return response.data;
    },

    deleteEPK: async () => {
        const response = await API.delete("/admin/epk/");
        return response.data;
    }
};
